/**
 * Returns a Kendo filter object for search box filtering.
 * @param {Array} data - The table data array.
 * @param {string} searchValue - The search box value.
 * @param {boolean} showSearchbox - Whether the search box is enabled.
 * @returns {Object|null} Kendo filter object or null.
 */
const getSearchFilter = (data, searchValue, useSearchbox) => {
  if (!useSearchbox || !searchValue || typeof searchValue !== 'string') {
    return null;
  }
  
  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }
  
  const firstRow = data[0];
  if (!firstRow || typeof firstRow !== 'object' || firstRow === null) {
    return null;
  }
  
  const keys = Object.keys(firstRow);
  if (keys.length === 0) {
    return null;
  }
  
  return {
    logic: "or",
    filters: keys.map(field => ({
      field,
      operator: "contains",
      value: searchValue
    }))
  };
}

/**
 * Combines Kendo filter and search filter objects.
 * @param {Object|null} filter - The Kendo filter object.
 * @param {Object|null} searchFilter - The search filter object.
 * @returns {Object|null} Combined filter object or null.
 */
const getCombinedFilter = (filter, searchFilter) => {
  if (!filter && !searchFilter) return null;
  if (filter && searchFilter) {
    return { logic: "and", filters: [filter, searchFilter] };
  }
  return filter || searchFilter || null;
}


export {
  getSearchFilter,
  getCombinedFilter
};